export class NutritionRating {

    public static getLastRating(nutritionRatings: NutritionRating[]): NutritionRating | undefined {
        if (!nutritionRatings || nutritionRatings.length === 0) {
            return;
        }
        return nutritionRatings
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
        [0];
    }

    public static getRatingsInDateRange(nutritionRatings: NutritionRating[], fromDate: Date, toDate: Date)
        : NutritionRating[] | undefined {
        if (!nutritionRatings || nutritionRatings.length === 0) {
            return;
        }
        return nutritionRatings
            .filter((rating) => {
                return new Date(rating.date).getTime() >= fromDate.getTime() &&
                    new Date(rating.date).getTime() <= toDate.getTime();
            })
            .map((rating) => ({
                date: new Date(rating.date),
                percent: parseFloat(rating.percent.toString()),
            }));
    }

    public static hasRatingForDateRange(nutritionRatings: NutritionRating[], fromDate: Date, toDate: Date): boolean {
        if (!nutritionRatings || nutritionRatings.length === 0) {
            return false;
        }
        return nutritionRatings
            .some((rating) => {
                return new Date(rating.date).getTime() >= fromDate.getTime() &&
                    new Date(rating.date).getTime() <= toDate.getTime();
            });
    }

    public static calculateRatingAverage(nutritionRatings: NutritionRating[], fromDate: Date, toDate: Date)
        : number | null {
        if (!nutritionRatings || nutritionRatings.length === 0) {
            return null;
        }

        const ratings = NutritionRating.getRatingsInDateRange(nutritionRatings, fromDate, toDate);
        if (ratings && ratings.length > 0) {
            return ratings
                .map((x) => x.percent)
                .reduce((a, b) => a + b, 0) / ratings.length;
        }

        return null;
    }

    public date: Date;
    public percent: number;
}
